import styled from 'styled-components';

import { base, theme } from '../../utils';

/**
 * Badge is small count and labeling component.
 */
const Badge = styled.span`
  ${theme('Badge')}
  ${base}
`;

export default Badge;
